module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAQlBMVEUAAABBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNBBiNDt8POtyeZIjNHm7PLR3+2Br91dmda1zuhfjexfAAAADXRSTlMA8Y0kTMy3rjMw5chRvQS2QgAAAIpJREFUGNN1kVsOhCAMRVsQRbCAj9n/Vscp3hAdPF/NSdPctlSZTQwSopmpYScBk4UcWBo8XFLuqLb8sPwbMsqTkcjLP54MypQSSkOxYx2FjmUSJadKFoVqrrKp3MrV60Q51lOuB+Yiw37aHRla3pwySt92K5+C3fp36N9MWW73Xd5/gb85Fnb42xedeRFLNYPBtAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_down2_hover.png
// module id = bZYs
// module chunks = 9